module.exports = __webpack_public_path__ + "img/fold.f3410ca9.svg";